import React from 'react';
import { Link } from 'react-router-dom';
import './ContactCTA.css';

const ContactCTA = () => {
  return (
    <section className="contact-cta-section home-section">
      <div className="cta-overlay"></div>
      <div className="contact-cta-content">
        <h2 className="contact-cta-title">Ready to Enhance Your Manufacturing Precision?</h2>
        <p className="contact-cta-text">
          Connect with our experts to discover how our high-quality tungsten carbide dies, diamond tools, 
          and abrasives can elevate your production processes. Our comprehensive website makes it easy to 
          find the right industrial tooling solutions for your specific business needs.
        </p>
        <div className="cta-buttons">
          <Link to="/contact" className="btn cta-btn primary">
            Request a Consultation
          </Link>
          <Link to="/products" className="btn cta-btn secondary">
            Explore Our Product Range
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
